/**
 * Badge — v4 status/label pill.
 * Tones: default (neutral), accent (violet), success (emerald), danger.
 */

import type { CSSProperties, ReactNode } from 'react';

export type BadgeTone = 'default' | 'accent' | 'success' | 'danger';

export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  /** Optional leading icon. */
  icon?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const TONE_CLASS: Record<BadgeTone, string> = {
  default: '',
  accent: 'v4-badge--accent',
  success: 'v4-badge--success',
  danger: 'v4-badge--danger',
};

export function Badge({ children, tone = 'default', icon, className, style }: BadgeProps) {
  const classes = ['v4-badge', TONE_CLASS[tone], className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <span className={classes} style={style}>
      {icon}
      {children}
    </span>
  );
}

export default Badge;
